import { NavLink, Link, useLocation } from "react-router-dom";
import { useCart } from "../context/CartContext.jsx";
import { useAuth } from "../context/AuthContext.jsx";

// App-style bottom tab bar — mobile only (hidden ≥680px, see .bnav in
// styles.css). Mirrors the header's own active-state rules so the two
// never disagree about which section you're in.
export default function BottomNav() {
  const { count } = useCart();
  const { user } = useAuth();
  const { pathname } = useLocation();
  const shopActive = pathname.startsWith("/products");
  const cartActive = pathname === "/cart";

  return (
    <nav className="bnav" aria-label="Primary">
      <NavLink to="/" end className={({ isActive }) => `bnav__tab ${isActive ? "active" : ""}`}>
        <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="m3 11 9-8 9 8" />
          <path d="M5 10v10a1 1 0 0 0 1 1h4v-6h4v6h4a1 1 0 0 0 1-1V10" />
        </svg>
        <span>Home</span>
      </NavLink>
      <Link to="/products" className={`bnav__tab ${shopActive ? "active" : ""}`}>
        <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M4 7h16l-1 4a3 3 0 0 1-3 2H8a3 3 0 0 1-3-2z" />
          <path d="M6 13v7h12v-7" />
          <path d="M9 7V5a3 3 0 0 1 6 0v2" />
        </svg>
        <span>Shop</span>
      </Link>
      <Link to="/cart" className={`bnav__tab bnav__tab--bag ${cartActive ? "active" : ""}`}>
        <span className="bnav__bag-icon">
          <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4H6z" />
            <path d="M3 6h18" />
            <path d="M16 10a4 4 0 0 1-8 0" />
          </svg>
          {count > 0 && <span className="bnav__badge">{count}</span>}
        </span>
        <span>Bag</span>
      </Link>
      <Link to={user ? "/account" : "/login"} className={`bnav__tab ${pathname === "/account" ? "active" : ""}`}>
        <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
          <circle cx="12" cy="7" r="4" />
        </svg>
        <span>{user ? "Account" : "Sign in"}</span>
      </Link>
    </nav>
  );
}
